import React from 'react';
import { BrainCog } from 'lucide-react';

const Header: React.FC = () => {
  return (
    <header className="rainbow-gradient text-white p-4 shadow-lg">
      <div className="container mx-auto flex items-center justify-center md:justify-start">
        <div className="w-8 h-8 mr-2 relative">
          <BrainCog size={32} className="text-white" />
        </div>
        <h1 className="text-2xl font-bold neon-glow">Mind Snack TV</h1>
      </div>
    </header>
  );
};

export default Header;